<!-- MIT License

Copyright (c) 2024 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->
<span class="password">
  <h1
    mat-dialog-title
    class="header"
    #bubbleTip="bubbleTip"
    bubbleTip="Always confirm your user name is correct. If so, enter a password and an optional hint to help you remember the password, then click Accept."
    bubblePosition="above"
    bubbleWidth="250px"
    bubbleShiftY="5"
    bubbleShiftX="-90">
    {{ userName }}
  </h1>
  <span mat-dialog-content class="dialog-content" (keyup.enter)="onAcceptClicked()">
    <p class="user-msg">
      Enter {{ encrypting ? "an encryption password" : "the password used for encryption" }}
      {{ loops > 1 ? " (loop " + loopCount + " of " + loops + ")" : "" }}
    </p>
    <div class="field-group">
      <mat-form-field class="field">
        <mat-label>Password</mat-label>
        <input
          id="password"
          matInput
          noAssist
          [ngModelOptions]="{ standalone: true }"
          autocomplete="new-password"
          data-1p-ignore
          data-bwignore="true"
          data-lpignore="true"
          data-form-type="other"
          [type]="hidePwd() ? 'password' : 'text'"
          (input)="onPasswordChange()"
          (blur)="checkPassword()"
          [(ngModel)]="passwd"
          autofocus />
        <mat-icon matSuffix (click)="hidePwd.set(!hidePwd())">{{
          hidePwd() ? "visibility_off" : "visibility"
        }}</mat-icon>
      </mat-form-field>
      <mat-form-field class="field">
        <mat-label>{{ encrypting ? "Optional Hint" : hint() ? "Hint" : "No Hint" }}</mat-label>
        <input
          id="hint"
          matInput
          noAssist
          type="text"
          [maxlength]="maxHintLen"
          [(ngModel)]="hint"
          [readonly]="!encrypting" />
      </mat-form-field>
    </div>
    @if (encrypting) {
      <div class="stren-meter">
        <div #strengthMsg class="stren-msg" [style.color]="strengthAlert() && minStrength >= 0 ? 'red' : 'black'">
          {{ strengthPhrase() }}
        </div>
        <app-strengthmeter
          (acceptableChanged)="onAcceptableChanged($event)"
          [minStrength]="minStrength"
          [pwned]="checkPwned"
          [password]="passwd()"
          [hint]="hint()"
          [usedPasswords]="usedPasswords"></app-strengthmeter>
      </div>
    } @else {
      <div class="spacer"></div>
    }
    <div mat-dialog-actions>
      <button class="accept-button" mat-button (click)="onAcceptClicked()">Accept</button>
    </div>
    <span
      class="cipher"
      [style.color]="cipherShow() ? 'black' : 'var(--mat-dialog-container-color, var(--mat-sys-surface, white))'"
      (click)="cipherShow.set(!cipherShow())">
      {{ cipherMode }}
    </span>
  </span>
  <!--last so it doesn't get focus-->
  <button class="close-button3" matSuffix mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</span>
